module.exports = __webpack_public_path__ + "static/desktop/img/template-baby.f30a9e0d.jpg";